/* tslint:disable */
/* eslint-disable */
/**
 * Warpgate Web Admin
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.22.0-beta.4-12-g918a4012-modified
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { LdapUsernameAttributeFromJSON, LdapUsernameAttributeToJSON, } from './LdapUsernameAttribute';
import { TlsModeFromJSON, TlsModeToJSON, } from './TlsMode';
/**
 * Check if a given object implements the UpdateLdapServerRequest interface.
 */
export function instanceOfUpdateLdapServerRequest(value) {
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('host' in value) || value['host'] === undefined)
        return false;
    if (!('port' in value) || value['port'] === undefined)
        return false;
    if (!('bindDn' in value) || value['bindDn'] === undefined)
        return false;
    if (!('userFilter' in value) || value['userFilter'] === undefined)
        return false;
    if (!('tlsMode' in value) || value['tlsMode'] === undefined)
        return false;
    if (!('tlsVerify' in value) || value['tlsVerify'] === undefined)
        return false;
    if (!('enabled' in value) || value['enabled'] === undefined)
        return false;
    if (!('autoLinkSsoUsers' in value) || value['autoLinkSsoUsers'] === undefined)
        return false;
    if (!('usernameAttribute' in value) || value['usernameAttribute'] === undefined)
        return false;
    if (!('sshKeyAttribute' in value) || value['sshKeyAttribute'] === undefined)
        return false;
    if (!('uuidAttribute' in value) || value['uuidAttribute'] === undefined)
        return false;
    return true;
}
export function UpdateLdapServerRequestFromJSON(json) {
    return UpdateLdapServerRequestFromJSONTyped(json, false);
}
export function UpdateLdapServerRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'name': json['name'],
        'host': json['host'],
        'port': json['port'],
        'bindDn': json['bind_dn'],
        'bindPassword': json['bind_password'] == null ? undefined : json['bind_password'],
        'userFilter': json['user_filter'],
        'tlsMode': TlsModeFromJSON(json['tls_mode']),
        'tlsVerify': json['tls_verify'],
        'enabled': json['enabled'],
        'autoLinkSsoUsers': json['auto_link_sso_users'],
        'description': json['description'] == null ? undefined : json['description'],
        'usernameAttribute': LdapUsernameAttributeFromJSON(json['username_attribute']),
        'sshKeyAttribute': json['ssh_key_attribute'],
        'uuidAttribute': json['uuid_attribute'],
    };
}
export function UpdateLdapServerRequestToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'name': value['name'],
        'host': value['host'],
        'port': value['port'],
        'bind_dn': value['bindDn'],
        'bind_password': value['bindPassword'],
        'user_filter': value['userFilter'],
        'tls_mode': TlsModeToJSON(value['tlsMode']),
        'tls_verify': value['tlsVerify'],
        'enabled': value['enabled'],
        'auto_link_sso_users': value['autoLinkSsoUsers'],
        'description': value['description'],
        'username_attribute': LdapUsernameAttributeToJSON(value['usernameAttribute']),
        'ssh_key_attribute': value['sshKeyAttribute'],
        'uuid_attribute': value['uuidAttribute'],
    };
}
